import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { GRAY, INFO } from '../../../../constants/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sendButton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'center',
      minWidth: 56,
      minHeight: 56,
      marginLeft: theme.spacing(1),
      borderRadius: 6,
      backgroundColor: INFO,
      '&:disabled': {
        backgroundColor: GRAY,
      },
      '& > *': {
        color: 'white',
      },
    },
  }),
);

export default useStyles;
